fragment SmallInstructionFragment on smallInstruction_Entry {
  typeHandle
  alt
  image {
    url
    title
  }
  heading
  body
  tagLine
}
